import { render, staticRenderFns } from "./FormulaIcon.vue?vue&type=template&id=b8a21f88"
import script from "./FormulaIcon.vue?vue&type=script&lang=js"
export * from "./FormulaIcon.vue?vue&type=script&lang=js"
import style0 from "./FormulaIcon.vue?vue&type=style&index=0&id=b8a21f88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports